import React from 'react';
import styled from 'styled-components';

import { Flex } from 'components';
import { ZINDEX } from 'shared/constants';

type Props = {
  onOpenUIClick: () => void;
};

export const OpenButton = (props: Props) => {
  const { onOpenUIClick } = props;

  return (
    <Button align justify onClick={onOpenUIClick}>
      DEV
    </Button>
  );
};

const Button = styled(Flex)`
  user-select: none;
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: 48px;
  height: 48px;
  font-size: 1.5em;
  font-weight: bold;
  background-color: #fab9b9;
  box-shadow: 0 0 10px black;
  border-radius: 8px;
  cursor: pointer;
  z-index: ${ZINDEX.OVERLAY};
`;
